export const serializeMenuSource = source => ({
  title: source.title,
  id: String(source.id),
});

export const serializeMenuSourceToMap = sources =>
  sources.map(source => serializeMenuSource(source));
